import { ExportModel } from "./ExportModel";
import { Audit } from "../../entities/Audit";
import { NotificationService } from "../../services/NotificationService";
import { CustomFieldNameService } from "../../services/CustomFieldNameService";
import { AuditService } from "../../services/AuditService";

export class AuditExportModel extends ExportModel<Audit>{
  static $inject = ['$q', 'AuditService', 'CustomFieldNameService', 'NotificationService'];
  constructor($q: ng.IQService, auditService: AuditService, public cfnService: CustomFieldNameService, public notifyService: NotificationService) {
    super($q, cfnService, auditService, notifyService);
  }
  getColumnDefs(): ng.IPromise<void> {
    this.nameValuePairs =
      [
        ['eventTime', 'Event Time', 230],
        ['username', 'Username', 150],
        ['action', 'Action', 150],
        ['recordType', 'Type', 150],
        ['recordID', 'ID', 150],
        ['name', 'Name', 150],
        ['description', 'Description', 230],
        ['rfidTag', 'Rfid Tag', 150],
        ['vTagID', 'V-Tag ID', 150],
        ['vTagGpsDeviceID', 'V-Tag GPS Device ID', 230],
        ['assetType', 'Asset Type', 150],
        ['departmentCode', 'Department', 150],
        ['lastObservedLocation', 'Last Observed Location', 150],
        ['lastObservedTime', 'Last Observed Time', 230],
      ]
    return this.$q.when();
  }
  getExportType() {
    return "Recent Changes";
  }
}
